import { render, staticRenderFns } from "./bottom-nav.vue?vue&type=template&id=14503c0f&scoped=true"
import script from "./bottom-nav.vue?vue&type=script&lang=js"
export * from "./bottom-nav.vue?vue&type=script&lang=js"
import style0 from "./bottom-nav.vue?vue&type=style&index=0&id=14503c0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14503c0f",
  null
  
)

export default component.exports